@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.stats {
  display: flex;
  align-items: center;
  background-color: transparent;
  border-radius: var(--cxy-border-radius-m);
  overflow: hidden;
  gap: var(--cxy-spacing-xsm);
}

.statsItem {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--cxy-spacing-xsm);
  gap: var(--cxy-spacing-xxxsm);
  text-align: center;
  color: var(--cxy-color-text-default-body);
  white-space: nowrap;

  &:not(:last-child) {
    border-right: 1px solid var(--cxy-color-border);
  }

  p {
    margin: 0;
  }
}

.statsItemTitle {
  @include cxy.font-size('text-xxs', var(--cxy-fontWeight-normal));

  @media (min-width: 768px) {
    @include cxy.font-size('text-m', var(--cxy-fontWeight-normal));
  }
}

.statsItemValue {
  @include cxy.font-size('subHeading-s-mobile', var(--cxy-fontWeight-semiBold));

  @media (min-width: 768px) {
    font-size: 24px;
    font-weight: var(--cxy-fontWeight-semiBold);
  }
}
